import { render, staticRenderFns } from "./VuesticCollapse.vue?vue&type=template&id=7af02e2e"
import script from "./VuesticCollapse.vue?vue&type=script&lang=js"
export * from "./VuesticCollapse.vue?vue&type=script&lang=js"
import style0 from "./VuesticCollapse.vue?vue&type=style&index=0&id=7af02e2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports